import { useState } from "react";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AdminSettings() {
  const { user } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) return toast.error("New passwords don't match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated");
      setCurrent(""); setNext(""); setConfirm("");
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <div className="h-full overflow-y-auto kl-scroll-light p-8" data-testid="admin-settings-page">
      <p className="kl-label">Account</p>
      <h1 className="font-display font-light text-3xl mt-1">Settings</h1>
      <p className="text-sm text-kl-mutedLight mt-1">Signed in as {user?.email}.</p>

      <form onSubmit={submit} className="kl-panel p-6 mt-6 max-w-md space-y-4" data-testid="admin-change-password-form">
        <p className="kl-label flex items-center gap-1.5"><KeyRound size={12} /> Change password</p>
        <label className="block">
          <span className="kl-label">Current password</span>
          <input type="password" required value={current} onChange={(e) => setCurrent(e.target.value)} className="kl-input-box mt-1" data-testid="admin-current-password-input" />
        </label>
        <label className="block">
          <span className="kl-label">New password</span>
          <input type="password" required minLength={6} value={next} onChange={(e) => setNext(e.target.value)} placeholder="at least 6 characters" className="kl-input-box mt-1" data-testid="admin-new-password-input" />
        </label>
        <label className="block">
          <span className="kl-label">Confirm new password</span>
          <input type="password" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} className="kl-input-box mt-1" data-testid="admin-confirm-password-input" />
        </label>
        <button disabled={busy} className="kl-btn-primary w-full h-11" data-testid="admin-change-password-submit">{busy ? "Updating…" : "Update password"}</button>
      </form>
    </div>
  );
}
